import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "importFile",
    "csvColumn",
    "step1Header",
    "step1Body",
    "step2Header",
    "fileName"
  ];
  static values = { file: String };

  showColumns() {
    this.readFile().then((values) => {
      this.populateSelect(values);
      this.step1HeaderTarget.classList.add("disabled");
      this.step1BodyTarget.classList.remove("open");
      this.step2HeaderTarget.classList.remove("disabled");
      this.step2HeaderTarget.click();
      this.fileNameTarget.textContent = this.importFileTarget.files[0].name;
    });
  }

  readFile() {
    return new Promise((resolve, reject) => {
      const file = this.importFileTargets[0].files[0];
      const reader = new FileReader();
      const values = [];
      reader.onload = (event) => {
        if (event.target) {
          const csvdata = event.target.result;
          if (csvdata) {
            const rowData = csvdata.split("\r\n");
            const rowColData = rowData[0].split(",");
            for (let col = 0; col < rowColData.length; col++) {
              const value = col + 1 + "-" + rowColData[col];
              values.push([value, col]);
            }
          }
        }
        resolve(values);
      };
      reader.onerror = reject;
      reader.readAsText(file);
    });
  }

  populateSelect(values) {
    for (let index = 0; index < this.csvColumnTargets.length; index++) {
      const selectBox = this.csvColumnTargets[index];
      selectBox.innerHTML = "";
      selectBox.appendChild(this.buildOption("", ""));
      for (let col = 0; col < values.length; col++) {
        selectBox.appendChild(this.buildOption(values[col][1], values[col][0]));
      }
    }
  }

  buildOption(value, label) {
    const opt = document.createElement("option");
    opt.value = value;
    opt.innerHTML = label;
    return opt;
  }
}
